import { inject, observer } from "mobx-react";
import ButtonUI from "@UI/ButtonUI";
import CardUI from "@UI/CardUI";
import { Fragment } from "react";

import "./style.scss";
import { useNavigationHandler } from "@hook";

const quickData = [
    { title: "Витрина", router: "projects" },
    { title: "Вендор", router: "offers" },
    { title: "Оффер", router: "companies" },
    { title: "А/Б оффер", router: "test-offer" },
];

const QuickActions = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();

        const handleClick = (e, router) => {
            mainStore.setMainStore("detailData", {});
            navigation(e, `/${router}/add`);
        };

        return (
            <CardUI title="Быстрые действия" className="quick">
                {quickData.map((item, idx) => (
                    <Fragment key={idx}>
                        <div className="quick__block">
                            <span className="quick__title">{item.title}</span>
                            <ButtonUI label="Добавить" severity="success" icon="pi pi-plus-circle" className="quick__button" onClick={(e) => handleClick(e, item.router)} />
                        </div>
                        {idx !== 3 ? <div className="quick__line"></div> : null}
                    </Fragment>
                ))}
            </CardUI>
        );
    }),
);
export default QuickActions;
